/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('hover-disclosure.grandparent').forEach(function (el) {
    let closeTimer = null;
    const originalHide = el.hideDisclosure.bind(el);

    el.hideDisclosure = function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        originalHide();
        closeTimer = null;
      }, 200);
    };

    el.addEventListener('mouseenter', function () {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    });
  });
});